import React from 'react'

import { useTCF } from 'components/TCFProvider'
import { useTCFConsents } from 'components/TCFConsentsProvider'

import TCFConsentSettingsHeader from '../TCFConsentSettingsHeader'
import TCFConsentTable from '../TCFConsentTable'

import Locale from './locale'
import Styles from './styles.scss'


export default function PurposesTabContent({ title }) {
  const { gvl } = useTCF()

  const purposes = gvl.getPurposes()
  const purposeVendorCounts = gvl.getPurposesVendorCounts()

  const specialFeatures = gvl.getSpecialFeatures()
  const specialFeatureVendorCounts = gvl.getSpecialFeaturesVendorCounts()

  const {
    isPurposeConsented,
    isSpecialFeatureConsented,
    setPurposeConsent,
    setSpecialFeatureConsent,
  } = useTCFConsents()

  return (
    <div className="tcfPurposesTabContent">
      <TCFConsentSettingsHeader
        subtitle={ Locale.purposesDescription }
        title={ title }
      />

      <div className={ Styles.purposesContainer }>
        <TCFConsentTable
          content={ purposes }
          handleConsentChange={ setPurposeConsent }
          isConsented={ isPurposeConsented }
          vendorCounts={ purposeVendorCounts }
          vendorType="tcf"
        />
      </div>

      <TCFConsentSettingsHeader
        subtitle={ Locale.specialFeaturesDescription }
        title={ Locale.specialFeatures }
      />

      <TCFConsentTable
        content={ specialFeatures }
        handleConsentChange={ setSpecialFeatureConsent }
        isConsented={ isSpecialFeatureConsented }
        vendorCounts={ specialFeatureVendorCounts }
        vendorType="tcf"
      />
    </div>
  )
}

PurposesTabContent.propTypes = {
  title: TCFConsentSettingsHeader.propTypes.title,
}
